module.exports = __webpack_public_path__ + "static/mobile-app-76abdeb5a3703beae363b6f691ab7f1c.png";